import React from 'react';
import {Link} from 'react-router';

var ListViewButtonSet = React.createClass({
  showPreview: function(slug){
    this.props.showPreview(slug);
  },
  editTheme: function(slug, accountSlug, type){
    // this.props.editTheme(slug, accountSlug, type);
    alert("Coming soon");
  },
  render: function(){
    return(
        <div className="theme-list__third-col">
            <div className="theme-list__buttons">
              {/*<ListViewPreviewButton value = {this.props.value} showPreview = {this.props.showPreview}/>*/}
              <ListViewDetailsButton value = {this.props.value} libName = {this.props.libName}/>
              <ListViewEditButton value = {this.props.value} editTheme= {this.editTheme}/>
            </div>
        </div>
      );
  }
});

var ListViewPreviewButton = React.createClass({
  handlePreviewClick: function(){
    this.props.showPreview(this.props.value["name"].split("/")[1]);
  },
  render: function(){
    return(
        <button className="btn__lg bg-white" onClick = {this.handlePreviewClick}><i className="fa fa-eye"></i> Preview</button>
    );
  }
});
var ListViewDetailsButton = React.createClass({
  render: function(){
        var slug, accountSlug, type;
        if(this.props.value != undefined){
           slug = this.props.value["name"].split("/")[1];   // this will set the value of slug so that we can send data in query url to next page(using react router)
           accountSlug = this.props.value["name"].split("/")[0];
           type = this.props.value["type"];
        }
    return(
          <Link to={{ pathname: '/details', query: {val: slug, account: accountSlug, lib: this.props.libName, type: type} }} className="btn__lg bg-very_light"><i className="fa fa-mail-forward"></i> Details</Link>
    );
  }
});
var ListViewEditButton = React.createClass({
  handleEditClick: function(){
    this.props.editTheme(this.props.value["name"].split("/")[1], this.props.value["name"].split("/")[0], this.props.value.type)
  },
  render: function(){
    return(
         <button className="btn__lg bg-dark" onClick = {this.handleEditClick}><i className="fa fa-pencil"></i> Edit</button>

    );
  }
});

export {ListViewButtonSet};


/** WEBPACK FOOTER **
 ** ./html/components/ListViewButtonSet.jsx
 **/